import type { CSSProperties } from 'react'

import type { BlueprintOpacityModifier } from '@/grove-blueprints/generated-types'

export function resolveOpacityModifier(
  modifier: BlueprintOpacityModifier,
): CSSProperties {
  if (matchMedia('(prefers-contrast: more)').matches) {
    return { opacity: 1 }
  }

  return { opacity: modifier.value }
}
